import { ReportSdk } from 'lib-klab-sdks';
import {
    DeviceFleetEmployeeItem,
    DeviceFleetEmployeeResponse,
    DeviceFleetItem,
    DeviceFleetPagination,
    DeviceFleetResponse,
} from '../../../domain/models/reports/device-fleet.model';

function nullable(value: string | null | undefined): string | null {
    return value === undefined || value === null || value === '' ? null : value;
}

export function mapSdkDeviceFleetItemToDomain(item: ReportSdk.AdminDeviceItem): DeviceFleetItem {
    return {
        deviceId: item?.deviceId ?? '',
        employeeId: item?.employeeId ?? 0,
        employeeName: nullable(item?.employeeName),
        deviceName: nullable(item?.deviceName),
        fingerprint: nullable(item?.fingerprint),
        osName: nullable(item?.osName),
        osVersion: nullable(item?.osVersion),
        agentVersion: nullable(item?.agentVersion),
        enrolledAt: nullable(item?.enrolledAt),
        lastLoginAt: nullable(item?.lastLoginAt),
        lastSeenAt: nullable(item?.lastSeenAt),
        hasActiveSession: Boolean(item?.hasActiveSession),
        deletedAt: nullable(item?.deletedAt),
    };
}

function mapPagination(page?: ReportSdk.PaginationResponse): DeviceFleetPagination {
    return {
        page: page?.page ?? 0,
        size: page?.size ?? 0,
        totalElements: page?.totalElements ?? 0,
        totalPages: page?.totalPages ?? 0,
    };
}

export function mapSdkDeviceFleetResponseToDomain(
    response: ReportSdk.AdminDeviceResponse,
): DeviceFleetResponse {
    return {
        items: (response?.content ?? []).map(mapSdkDeviceFleetItemToDomain),
        page: mapPagination(response?.page),
    };
}

export function mapSdkDeviceFleetEmployeeItemToDomain(
    item: ReportSdk.AdminDeviceEmployeeItem,
): DeviceFleetEmployeeItem {
    return {
        employeeId: item?.employeeId ?? 0,
        employeeName: nullable(item?.employeeName),
        deviceCount: item?.deviceCount ?? 0,
        upToDateCount: item?.upToDateCount ?? 0,
        outdatedCount: item?.outdatedCount ?? 0,
        withoutVersionCount: item?.withoutVersionCount ?? 0,
        lastSeenAt: nullable(item?.lastSeenAt),
    };
}

export function mapSdkDeviceFleetEmployeeResponseToDomain(
    response: ReportSdk.AdminDeviceEmployeeResponse,
): DeviceFleetEmployeeResponse {
    return {
        items: (response?.content ?? []).map(mapSdkDeviceFleetEmployeeItemToDomain),
        availableVersions: response?.availableVersions ?? [],
        page: mapPagination(response?.page),
    };
}
